module.exports = __webpack_public_path__ + "static/media/S4N9-2.f63aa921.svg";